import { useState, useEffect, useMemo} from 'react'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { writesettings  } from '../../../redux/actions';
import BtnForward from '../BtnGrup/BtnForward/BtnForward';
import BtnRevers from '../BtnGrup/BtnRevers/BtnRevers';
import BtnStop from '../BtnGrup/BtnStop/BtnStop';
import BtnPersent from '../BtnCalc/BtnPersent/BtnPersent';
import BtnHydro from '../BtnCalc/BtnHydro/BtnHydro';
import BtnTime from '../BtnCalc/BtnTime/BtnTime';
import Checkbox from '../../UI/Checkbox/Checkbox';
import { checkDeviceLink } from '../../Utils/DateFormatter';
import { checkBit } from '../../Utils/Functions';
import water from '../../../img/water-tap.png';
import './DmCommands.css';

export default function DmCommands() {
    const parameter = useSelector((state) => state.dmimei?.data[0]);
    const dispatch = useDispatch();

    const state = parameter?.param4 ?? '...';
    const imei = parameter?.imei ?? '...';
    const param_last_date = parameter?.param_last_date ?? 0;

    const islink = useMemo(() => {
        const browserTime = new Date();
        return checkDeviceLink(param_last_date, browserTime) ? 'Online' : 'Offline';
    }, [param_last_date]);

    const [checkedWater, setCheckedWater] = useState();

    useEffect(() => {  
        setCheckedWater (checkBit(parameter?.param4, 3)) //то режим "без воды", круг зелёный, слайсер влево
        }, [parameter?.param4]);   

    const handleCheckboxChange=(event)=>{ 

        const isChecked = event.target.checked;
        setCheckedWater(isChecked);
        let inputvalue;
        let num;

        if (isChecked) { num=80; inputvalue=2;} // "Без воды"
        else if (!isChecked) { num=81; inputvalue=1;}// "С водой"

        dispatch(writesettings(parameter?.imei, inputvalue, num))
        .then(() => {
            console.log("Данные обновлены");
            alert(`Команда включить режим "${checkedWater ? 'С водой' : 'Без воды'}" отправлена`);
        })
        .catch((error) => console.error("Ошибка при сохранении или обновлении данных: ", error)); 
        }

    return(
        <div className='dmDetalsCommand'> 
            <div className='commandHeader'>
                <h4>Управление</h4> 
            </div>
            <div className='commandBlock'>
                <BtnRevers islink={islink} state={state} imei={imei} />
                <BtnStop imei={imei} />
                <BtnForward islink={islink} state={state} imei={imei} /> 
                <div className='commandBlockSwitch'> 
                    <img  src={water} alt="Result" />
                    <Checkbox handleCheckboxChange={handleCheckboxChange}  /*checked={checked}*/
                     checked={checkedWater} id="checkbox1" /> 
                </div> 
            </div>
            <div className='commandRegulation'>
            <BtnPersent />
            <BtnHydro />
            <BtnTime />                     
            </div>
        </div>
    )
}